import { useContext } from 'react';
import { AceiteDePagamentoContext } from '../context/AceiteDePagamentoContext';

export const useAceiteDePagamento = (): any =>
  useContext(AceiteDePagamentoContext);
